export enum UNLEASH_TOGGLES {
  CHECK_IN_KIOSK_BROTHER_SDK = 'check-in-kiosk.brother-sdk',
  CHECKIN_PRECHECK = 'check-in.pre-check',
  MEDIA_KING_JAMES_TRANSLATION = 'media.king-james-translation',
  MEDIA_SUPPRESS_PROGRESS_TRACKING = 'media.suppress-progress-tracking',
  MEDIA_UNIVERSAL_PLAYER_IN_WEBSHELL = 'media.universal-player-in-webshell-media-detail-page',
  DISPATCH_GROUP_ATTENDANCE = 'dispatch.group-attendance',
}
